import {
    UPDATE_SUCURSAL,
  } from "./actionTypes"

  export const update_sucursal = sucursal => {
    return {
      type: UPDATE_SUCURSAL,
      payload: sucursal,
    }
  }